import { useMemo } from 'react'

import { SHIPPING_STATUS_CODES } from '../../common/constants'
import useTranslations from '../../i18n/useTranslations'

import { STATUS_CODE_FILTER_ORDER } from './constants'

const STATUS_CODE_LABEL_MAP = {
  [SHIPPING_STATUS_CODES.manifested]: 'tracking:recorded',
  [SHIPPING_STATUS_CODES.collected]: 'tracking:collected',
  [SHIPPING_STATUS_CODES.inTransit]: 'tracking:in-transit',
  [SHIPPING_STATUS_CODES.delivering]: 'tracking:distribution',
  [SHIPPING_STATUS_CODES.pudo]: 'tracking:pudo',
  [SHIPPING_STATUS_CODES.delivered]: 'tracking:delivered',
  [SHIPPING_STATUS_CODES.returned]: 'tracking:returned',
  [SHIPPING_STATUS_CODES.cancelled]: 'tracking:cancelled',
  'separator:pudo': 'separator:pudo',  
  [SHIPPING_STATUS_CODES.depositPending]: 'tracking:depositPending',
  [SHIPPING_STATUS_CODES.deposited]: 'tracking:deposited',
}

const useStatusCodeFilterOptions = isOptionChecked => {
  const t = useTranslations()

  return useMemo(
    () =>
      STATUS_CODE_FILTER_ORDER.map(statusCode => ({
        id: statusCode,
        label: t(STATUS_CODE_LABEL_MAP[statusCode]),
        checked: isOptionChecked(statusCode),
      })),
    [t, isOptionChecked],
  )
}

export default useStatusCodeFilterOptions
